module.exports = __webpack_public_path__ + "img/Angiogenesis-OVCA_GSE227019.8f32a1d4.png";